<template>
  <div>
    <m-table
      :parent-col.sync="colList"
      :data="tableData"
      :is-edit="true"
      :default-sort="{prop: 'date', order: 'descending'}"
    >
      <m-column v-for="(item,index) in colList" :key="index" :col="item">
      </m-column>
    </m-table>
  </div>
</template>

<script>
import mTable from '@/components/mTable';
import mColumn from '@/components/mTable/mColumn';

export default {
  name: 'demo',
  components: {
    mTable,
    mColumn,
  },
  data() {
    return {
      colList: [
        {
          label: '日期',
          prop: 'date',
          width: 200,
          sortable: true,
          uid: 1,
          type: 'input',
          readOnly: false,
        },
        {
          label: '配送信息',
          width: 320,
          uid: 2,
          children: [
            {
              label: '姓名',
              prop: 'name',
              width: 80,
              uid: 3,
              readOnly: true,
            },
            {
              label: '地址',
              width: 240,
              uid: 4,
              children: [
                {
                  label: '省份',
                  prop: 'province',
                  sortable: true,
                  width: 80,
                  uid: 5,
                  readOnly: true,
                },
                {
                  label: '市区',
                  prop: 'city',
                  width: 80,
                  uid: 6,
                  readOnly: true,
                }, {
                  label: '地址',
                  prop: 'address',
                  width: 80,
                  uid: 7,
                  readOnly: true,
                },
              ],
            },
          ],
        },
      ],
      tableData: [{
        uid: 1,
        date: '2016-05-03',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333,
      }, {
        uid: 2,
        date: '2016-05-02',
        name: '王小虎',
        province: '湖州',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333,
      }, {
        uid: 3,
        date: '2016-05-04',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333,
      }, {
        uid: 4,
        date: '2016-05-01',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333,
      }, {
        uid: 5,
        date: '2016-05-08',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333,
      }, {
        uid: 6,
        date: '2016-05-06',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333,
      }, {
        uid: 7,
        date: '2016-05-07',
        name: '王小虎',
        province: '上海',
        city: '普陀区',
        address: '上海市普陀区金沙江路 1518 弄',
        zip: 200333,
      }],
    };
  },
};
</script>

<style scoped>

</style>
